import { TicketLink } from '@dustin-web/product-components/src/ticket-link'
import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import { Icon } from '@dustin-web/microsite-components/src/icon-library'
import { getProductUrl } from '@dustin-web/microsite-components/src/utils/urls'

type Props = {
  productErpIdentifier: string
  productNameSlug: string | undefined
}
const ProductOutOfStock = ({ productErpIdentifier, productNameSlug }: Props) => {
  const { translate } = useI18n()

  const productUrl = getProductUrl(productErpIdentifier, productNameSlug || '')

  return (
    <>
      <div className="u-color-danger u-mr-16">
        {translate('Product_LifeCycleStateMessage_ClearanceAndOutOfStock')}
      </div>
      <TicketLink className="u-w-100" url={productUrl} ticket={''}>
        {translate('Product_EOL_Similar_Products_Accessories')}
        <Icon
          name="arrow-right-small"
          className="i-24"
          style={{ verticalAlign: 'middle' }}
        />
      </TicketLink>
    </>
  )
}

export default ProductOutOfStock
